var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", { staticClass: "table", style: _vm.cssVars }, [
    _c("thead", [
      _c("tr", { staticClass: "col-definition" }, [
        _c("th", { style: { width: _vm.beforeImageWidth } }),
        _c("th"),
        _c("th", { style: { width: _vm.afterImageWidth } }),
      ]),
      _c("tr", { staticClass: "title-line" }, [
        _c("th", { attrs: { colspan: "3" } }, [
          _c(
            "div",
            { staticClass: "table-line-wrap" },
            _vm._l(_vm.titleLine, function (col, i) {
              return _c(
                "span",
                {
                  key: i,
                  style: {
                    width: col.getWidth(),
                    left: _vm.getLeft(_vm.titleLine, col),
                  },
                },
                [
                  _c("span", { style: { ...col.Style.getStyle() } }, [
                    _vm._v(_vm._s(col.Text.getTranslation(_vm.lang))),
                  ]),
                  _c("span", { style: { ...col.PropStyle.getStyle() } }, [
                    _vm._v(_vm._s(col.getPropName())),
                  ]),
                  _c("span", { style: { ...col.AfterTextStyle.getStyle() } }, [
                    _vm._v(_vm._s(col.TextAfter.getTranslation(_vm.lang))),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _c("tr", { staticClass: "date-line" }, [
        _c(
          "th",
          {
            style: {
              background: _vm.pageSettings.DefaultBackgroundColor,
              borderColor: _vm.pageSettings.DefaultBorderColor,
              borderWidth: _vm.pageSettings.DefaultBorderSize + "px",
            },
            attrs: { colspan: "3" },
          },
          [
            _c(
              "div",
              { staticClass: "table-line-wrap" },
              _vm._l(_vm.dateLine, function (col, i) {
                return _c(
                  "span",
                  {
                    key: i,
                    style: {
                      width: col.getWidth(),
                      left: _vm.getLeft(_vm.dateLine, col),
                      backgroundColor: _vm.pageSettings.DefaultBackgroundColor,
                    },
                  },
                  [
                    _c("span", { style: { ...col.Style.getStyle() } }, [
                      _vm._v(_vm._s(col.Text.getTranslation(_vm.lang))),
                    ]),
                    _c("span", { style: { ...col.PropStyle.getStyle() } }, [
                      _vm._v(_vm._s(col.getPropName())),
                    ]),
                    _c(
                      "span",
                      { style: { ...col.AfterTextStyle.getStyle() } },
                      [_vm._v(_vm._s(col.TextAfter.getTranslation(_vm.lang)))]
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ]),
      _c("tr", [
        _c("th", { attrs: { colspan: "3" } }, [
          _c(
            "div",
            { staticClass: "detail-row" },
            _vm._l(_vm.headerCols, function (col, i) {
              return _c(
                "div",
                { key: i, staticClass: "table-col", style: _vm.getStyle(col) },
                [_vm._v(" " + _vm._s(col.getHeadingText(_vm.lang)) + " ")]
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
    _c("tbody", [
      _c("tr", [
        _c(
          "td",
          {
            staticClass: "image-col",
            style: { width: _vm.beforeImageWidth, padding: 0 },
          },
          [_c("app-details-image", { attrs: { value: _vm.beforeImage } })],
          1
        ),
        _c("td"),
        _c(
          "td",
          {
            staticClass: "image-col",
            style: { width: _vm.afterImageWidth, padding: 0 },
          },
          [_c("app-details-image", { attrs: { value: _vm.afterImage } })],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }